(() => {
        const root = document.querySelector("[data-bb-mertini-root]");
        if (!root || root.dataset.mertiniInitialized === "true") return;
        root.dataset.mertiniInitialized = "true";
        const requestedMotion = new URLSearchParams(window.location.search).get("motion");
        if (requestedMotion === "1") root.classList.add("motion-on");
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
        const motionOverride = root.classList.contains("motion-on");
        const motionReduced = reduced.matches && !motionOverride;
        const saveData = navigator.connection?.saveData === true;
        const staticChase = motionReduced || saveData;
        const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)");
        const chaseVideo = root.querySelector("[data-chase-video]");
        const chaseTimecode = root.querySelector("[data-hero-timecode]");
        const autoplayVideos = [...root.querySelectorAll("[data-autoplay-video]")];
        const motionToggle = root.querySelector("[data-motion-toggle]");
        const motionLabel = root.querySelector("[data-motion-label]");
        const revealItems = root.querySelectorAll("[data-reveal]");
        const visibleAutoplayVideos = new Set();
        let chaseDuration = 8.041667;
        let chaseProgress = 0;
        let chaseTargetTime = 0;
        let chaseFailed = false;
        let chaseStallTimer = 0;
        let ambientMotionPaused = false;

        const formatChaseTime = (seconds) => {
          const wholeSeconds = Math.max(0, Math.min(8, Math.floor(seconds)));
          return `00:${String(wholeSeconds).padStart(2, "0")}`;
        };

        const commitChaseFrame = () => {
          if (!chaseVideo || chaseFailed || chaseVideo.readyState < 1 || chaseVideo.seeking || document.hidden) return;
          const maxTime = Math.max(0, chaseDuration - 0.04);
          const nextTime = staticChase ? 0 : Math.max(0, Math.min(maxTime, chaseTargetTime));
          if (Math.abs(chaseVideo.currentTime - nextTime) < 0.024) return;
          try {
            chaseVideo.currentTime = nextTime;
          } catch {

          }
        };

        const syncChaseFrame = (progress) => {
          chaseProgress = Math.max(0, Math.min(1, progress));
          chaseTargetTime = chaseProgress * Math.max(0, chaseDuration - 0.04);
          if (chaseTimecode) {
            chaseTimecode.textContent = chaseProgress >= 0.995 ? "00:08" : formatChaseTime(chaseTargetTime);
          }
          commitChaseFrame();
        };

        const useStaticChase = () => {
          if (!chaseVideo || chaseFailed) return;
          chaseFailed = true;
          window.clearTimeout(chaseStallTimer);
          chaseVideo.pause();
          chaseVideo.closest(".campaign-hero")?.classList.add("is-static-film");
          if (chaseTimecode) chaseTimecode.textContent = "00:00";
        };

        if (chaseVideo) {
          chaseVideo.defaultMuted = true;
          chaseVideo.pause();
          const prepareChaseVideo = () => {
            if (Number.isFinite(chaseVideo.duration) && chaseVideo.duration > 0) {
              chaseDuration = chaseVideo.duration;
            }
            syncChaseFrame(chaseProgress);
          };
          if (staticChase) {
            chaseVideo.closest(".campaign-hero")?.classList.add("is-static-film");
          } else {
            chaseVideo.addEventListener("loadedmetadata", prepareChaseVideo, { once: true });
            const loadChaseVideo = () => {
              if (chaseFailed || chaseVideo.hasAttribute("src")) return;
              chaseVideo.preload = "auto";
              chaseVideo.src = window.innerWidth <= 860
                ? chaseVideo.dataset.srcMobile
                : chaseVideo.dataset.srcDesktop;
              chaseVideo.load();
            };
            if (document.readyState === "complete") {
              window.requestAnimationFrame(loadChaseVideo);
            } else {
              window.addEventListener("load", loadChaseVideo, { once: true });
            }
          }
          chaseVideo.addEventListener("error", useStaticChase, { once: true });
          chaseVideo.addEventListener("stalled", () => {
            window.clearTimeout(chaseStallTimer);
            chaseStallTimer = window.setTimeout(() => {
              if (chaseVideo.readyState < 2) useStaticChase();
            }, 3500);
          });
          chaseVideo.addEventListener("canplay", () => window.clearTimeout(chaseStallTimer));
          chaseVideo.addEventListener("seeked", commitChaseFrame);
          document.addEventListener("visibilitychange", () => {
            chaseVideo.pause();
            if (!document.hidden) commitChaseFrame();
          });
        }

        const updateMotionControl = () => {
          if (!motionToggle || !motionLabel) return;
          const forcedOff = motionReduced || saveData;
          motionToggle.disabled = forcedOff;
          motionToggle.classList.toggle("is-paused", forcedOff || ambientMotionPaused);
          motionToggle.setAttribute("aria-pressed", String(forcedOff || ambientMotionPaused));
          motionLabel.textContent = motionReduced
            ? "Motion reduced"
            : saveData
              ? "Data saver"
              : ambientMotionPaused
                ? "Motion paused"
                : "Motion on";
        };

        const prepareAutoplayVideo = (video) => {
          if (video.dataset.mediaReady === "true" || !video.dataset.src) return;
          video.dataset.mediaReady = "true";
          video.preload = "metadata";
          video.src = video.dataset.src;
          video.load();
        };

        const playAutoplayVideo = (video) => {
          if (motionReduced || saveData || ambientMotionPaused || document.hidden) return;
          prepareAutoplayVideo(video);
          video.play().catch(() => {});
          video.classList.add("is-playing");
        };

        motionToggle?.addEventListener("click", () => {
          if (motionReduced || saveData) return;
          ambientMotionPaused = !ambientMotionPaused;
          if (ambientMotionPaused) {
            autoplayVideos.forEach((video) => {
              video.pause();
              video.classList.remove("is-playing");
            });
          } else {
            visibleAutoplayVideos.forEach(playAutoplayVideo);
          }
          updateMotionControl();
        });
        updateMotionControl();

        reduced.addEventListener?.("change", () => {
          if (!motionOverride) window.location.reload();
        });

        if (!motionReduced && !saveData && "IntersectionObserver" in window) {
          const videoObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting && entry.intersectionRatio >= 0.28 && !document.hidden) {
                  visibleAutoplayVideos.add(video);
                  playAutoplayVideo(video);
                } else {
                  visibleAutoplayVideos.delete(video);
                  video.pause();
                  video.classList.remove("is-playing");
                }
              });
            },
            { threshold: [0, 0.28, 0.65], rootMargin: "180px 0px" }
          );
          autoplayVideos.forEach((video) => videoObserver.observe(video));
          document.addEventListener("visibilitychange", () => {
            if (document.hidden) {
              autoplayVideos.forEach((video) => video.pause());
            } else {
              visibleAutoplayVideos.forEach(playAutoplayVideo);
            }
          });
        }

        if (motionReduced || !("IntersectionObserver" in window)) {
          revealItems.forEach((item) => item.classList.add("is-visible"));
        } else {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
              });
            },
            { threshold: 0.14, rootMargin: "0px 0px -7% 0px" }
          );
          revealItems.forEach((item) => observer.observe(item));
        }

        const discover = root.querySelector("[data-discover]");
        discover?.addEventListener("click", () => {
          root.querySelector("#story")?.scrollIntoView({
            behavior: motionReduced ? "auto" : "smooth"
          });
        });

        const hero = root.querySelector(".hero");
        const heroInstrument = root.querySelector(".hero__instrument");
        if (hero && finePointer.matches && !motionReduced) {
          hero.addEventListener("pointermove", (event) => {
            const bounds = hero.getBoundingClientRect();
            const x = ((event.clientX - bounds.left) / bounds.width) * 100;
            const y = ((event.clientY - bounds.top) / bounds.height) * 100;
            root.style.setProperty("--mx", `${x}%`);
            root.style.setProperty("--my", `${y}%`);
            heroInstrument?.style.setProperty("--instrument-turn", `${(x - 50) * 0.08}deg`);
          });
        }

        const header = root.querySelector(".site-header");
        const raceChapters = [...root.querySelectorAll("[data-race-chapter]")];
        const threadIndex = root.querySelector("[data-thread-index]");
        const threadLabel = root.querySelector("[data-thread-label]");
        const raceHero = root.querySelector("[data-race-hero]");
        const precision = root.querySelector("[data-precision]");
        const shotSequence = root.querySelector("[data-shot]");
        const readoutLabel = root.querySelector("[data-readout-label]");
        const readoutValue = root.querySelector("[data-readout-value]");
        const readouts = [
          ["Brew boiler", "0.25 L"],
          ["Steam boiler", "1.6 L"],
          ["Water reservoir", "2.0 L"]
        ];
        const editionWall = root.querySelector("[data-edition-wall]");
        const editionCanvas = root.querySelector("[data-edition-canvas]");
        const editionCount = root.querySelector("[data-edition-count]");
                let editionPoints = [];
        let editionContext = null;
        let editionWidth = 0;
        let editionHeight = 0;
        let editionProgress = motionReduced ? 1 : 0;
        let lastEditionDraw = -1;
        let activeRaceChapter = null;
        let globalPending = false;

        const clamp01 = (value) => Math.max(0, Math.min(1, value));
        const smoothstep = (value) => {
          const x = clamp01(value);
          return x * x * (3 - 2 * x);
        };

        const setupEditionWall = () => {
          if (!editionCanvas) return;
          const bounds = editionCanvas.getBoundingClientRect();
          const dpr = Math.min(2, window.devicePixelRatio || 1);
          editionWidth = Math.max(1, bounds.width);
          editionHeight = Math.max(1, bounds.height);
          editionCanvas.width = Math.round(editionWidth * dpr);
          editionCanvas.height = Math.round(editionHeight * dpr);
          editionContext = editionCanvas.getContext("2d");
          editionContext.setTransform(dpr, 0, 0, dpr, 0, 0);
          lastEditionDraw = -1;

          const mask = document.createElement("canvas");
          const maskWidth = 1000;
          const maskHeight = 440;
          mask.width = maskWidth;
          mask.height = maskHeight;
          const maskContext = mask.getContext("2d", { willReadFrequently: true });
          maskContext.fillStyle = "#000";
          maskContext.font = "900 360px 'Instrument Sans', Arial, sans-serif";
          maskContext.textAlign = "center";
          maskContext.textBaseline = "middle";
          maskContext.fillText("911", maskWidth / 2, maskHeight / 2 + 8);
          const pixels = maskContext.getImageData(0, 0, maskWidth, maskHeight).data;
          const selected = [];
          let seen = 0;
          let seed = 9111973;
          const random = () => {
            seed = (seed * 1664525 + 1013904223) >>> 0;
            return seed / 4294967296;
          };

          for (let y = 2; y < maskHeight; y += 3) {
            for (let x = 2; x < maskWidth; x += 3) {
              if (pixels[(y * maskWidth + x) * 4 + 3] < 100) continue;
              const candidate = { x: x / maskWidth, y: y / maskHeight };
              seen += 1;
              if (selected.length < 911) {
                selected.push(candidate);
              } else {
                const replace = Math.floor(random() * seen);
                if (replace < 911) selected[replace] = candidate;
              }
            }
          }

          const columns = Math.ceil(Math.sqrt(911 * (editionWidth / editionHeight)));
          const rows = Math.ceil(911 / columns);
          editionPoints = selected.map((target, index) => {
            const column = index % columns;
            const row = Math.floor(index / columns);
            return {
              sx: ((column + 0.5 + (random() - 0.5) * 0.42) / columns) * editionWidth,
              sy: ((row + 0.5 + (random() - 0.5) * 0.42) / rows) * editionHeight,
              tx: editionWidth * (0.17 + target.x * 0.68),
              ty: editionHeight * (0.2 + target.y * 0.56),
              tone: index % 17 === 0 ? "red" : index % 7 === 0 ? "blue" : "ink"
            };
          });
        };

        const drawEditionWall = (progress) => {
          if (!editionContext || editionPoints.length < 911) return;
          const quantized = progress >= 0.999 ? 1 : Math.round(progress * 500) / 500;
          if (quantized === lastEditionDraw) return;
          lastEditionDraw = quantized;
          progress = quantized;
          editionContext.clearRect(0, 0, editionWidth, editionHeight);
          const formation = smoothstep((progress - 0.06) / 0.66);
          const visibleCount = Math.min(911, Math.round(911 * clamp01(progress / 0.62)));
          const radius = editionWidth < 700 ? 1.15 : 1.6;

          for (let index = 0; index < visibleCount; index += 1) {
            const point = editionPoints[index];
            const delay = (index / 911) * 0.18;
            const local = smoothstep((formation - delay) / Math.max(0.001, 1 - delay));
            const x = point.sx + (point.tx - point.sx) * local;
            const y = point.sy + (point.ty - point.sy) * local;
            if (point.tone === "red") {
              editionContext.fillStyle = `rgba(217, 47, 61, ${0.45 + local * 0.5})`;
            } else if (point.tone === "blue") {
              editionContext.fillStyle = `rgba(14, 121, 168, ${0.42 + local * 0.5})`;
            } else {
              editionContext.fillStyle = `rgba(9, 11, 10, ${0.24 + local * 0.62})`;
            }
            editionContext.beginPath();
            editionContext.arc(x, y, radius + local * 0.35, 0, Math.PI * 2);
            editionContext.fill();
          }

          if (editionCount) editionCount.textContent = String(visibleCount).padStart(3, "0");
        };

        setupEditionWall();
        document.fonts?.ready.then(() => {
          setupEditionWall();
          drawEditionWall(editionProgress);
        });

        const activeSystems = new WeakSet();
        const systemNodes = [raceHero, editionWall, shotSequence, precision].filter(Boolean);
        if ("IntersectionObserver" in window) {
          const systemObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) activeSystems.add(entry.target);
                else activeSystems.delete(entry.target);
              });
              requestAnimationFrame(updateScrollSystems);
            },
            { rootMargin: "100% 0px", threshold: 0 }
          );
          systemNodes.forEach((node) => {
            const bounds = node.getBoundingClientRect();
            if (bounds.bottom > -window.innerHeight && bounds.top < window.innerHeight * 2) activeSystems.add(node);
            systemObserver.observe(node);
          });
        } else {
          systemNodes.forEach((node) => activeSystems.add(node));
        }
        const isSystemActive = (node) => motionReduced || activeSystems.has(node);

        const updateRaceThread = () => {
          if (!raceChapters.length) return;
          const probe = window.innerHeight * 0.46;
          let active = raceChapters[0];

          for (const chapter of raceChapters) {
            const bounds = chapter.getBoundingClientRect();
            if (bounds.top > probe) break;
            active = chapter;
            if (bounds.bottom > probe) break;
          }

          if (active === activeRaceChapter) return;
          activeRaceChapter = active;
          if (threadIndex) threadIndex.textContent = active.dataset.raceChapter;
          if (threadLabel) threadLabel.textContent = active.dataset.raceLabel;
          root.dataset.raceTone = active.dataset.raceTone || "dark";
        };

        const updateScrollSystems = () => {
          const scrollable = document.documentElement.scrollHeight - window.innerHeight;
          const pageProgress = scrollable > 0 ? window.scrollY / scrollable : 0;
          root.style.setProperty("--page-progress", String(Math.max(0, Math.min(1, pageProgress))));
          header?.classList.toggle("is-scrolled", window.scrollY > 70);
          updateRaceThread();

          if (raceHero && isSystemActive(raceHero)) {
            const bounds = raceHero.getBoundingClientRect();
            const sticky = raceHero.querySelector(".campaign-hero__sticky");
            const travel = raceHero.offsetHeight - (sticky?.offsetHeight || window.innerHeight);
            const progress = motionReduced || travel <= 0
              ? 0
              : clamp01(-bounds.top / travel);
            const mobileHero = window.innerWidth <= 860;
            const mobileFocus = 42 + smoothstep(progress / 0.48) * 8;
            const driveOpacity = 1 - smoothstep((progress - 0.72) / 0.2);
            const copyOpacity = 1 - smoothstep((progress - 0.22) / 0.3);

            chaseProgress = progress;
            syncChaseFrame(progress);
            raceHero.style.setProperty("--race-progress", progress.toFixed(4));
            raceHero.style.setProperty("--hero-focus", mobileHero ? `${mobileFocus.toFixed(2)}%` : "50%");
            raceHero.style.setProperty("--copy-opacity", copyOpacity.toFixed(3));
            raceHero.style.setProperty("--drive-opacity", driveOpacity.toFixed(3));
          }

          if (editionWall && isSystemActive(editionWall)) {
            const bounds = editionWall.getBoundingClientRect();
            const travel = editionWall.offsetHeight - window.innerHeight;
            editionProgress = motionReduced || travel <= 0
              ? 1
              : clamp01(-bounds.top / travel);
            const intro = 1 - smoothstep((editionProgress - 0.24) / 0.24);
            const final = smoothstep((editionProgress - 0.62) / 0.22);
            editionWall.style.setProperty("--edition-intro", intro.toFixed(3));
            editionWall.style.setProperty("--edition-final", final.toFixed(3));
            drawEditionWall(editionProgress);
          }

          if (!motionReduced) {
                        if (shotSequence && isSystemActive(shotSequence)) {
              const bounds = shotSequence.getBoundingClientRect();
              const travel = shotSequence.offsetHeight - window.innerHeight;
              const progress = travel > 0 ? Math.max(0, Math.min(1, -bounds.top / travel)) : 0;
              const inset = 11 * (1 - Math.min(1, progress * 1.18));
              const scale = 1.14 - progress * 0.14;
              const copy = Math.max(0, Math.min(1, (progress - 0.08) * 3.7));

              shotSequence.style.setProperty("--shot-inset", `${inset.toFixed(2)}%`);
              shotSequence.style.setProperty("--shot-scale", scale.toFixed(3));
              shotSequence.style.setProperty("--shot-copy", copy.toFixed(3));
            }

            if (precision && isSystemActive(precision)) {
              const bounds = precision.getBoundingClientRect();
              const travel = precision.offsetHeight - window.innerHeight;
              const progress = travel > 0 ? Math.max(0, Math.min(1, -bounds.top / travel)) : 0;
              const step = Math.min(2, Math.floor(Math.min(0.999, progress) * 3));
              const scale = 0.8 + progress * 0.22;
              const turn = -7 + progress * 14;
              const shift = (progress - 0.5) * 34;

              precision.dataset.step = String(step);
              precision.style.setProperty("--precision-scale", scale.toFixed(3));
              precision.style.setProperty("--precision-turn", `${turn.toFixed(2)}deg`);
              precision.style.setProperty("--precision-x", `${shift.toFixed(1)}px`);
              precision.style.setProperty("--precision-gauge", `${(progress * 250).toFixed(1)}deg`);
              precision.style.setProperty("--precision-orbit", `${(progress * -105).toFixed(1)}deg`);
              precision.style.setProperty("--precision-rail", progress.toFixed(3));

              if (readoutLabel && readoutValue) {
                readoutLabel.textContent = readouts[step][0];
                readoutValue.textContent = readouts[step][1];
              }
            }
          }

          globalPending = false;
        };

        window.addEventListener(
          "scroll",
          () => {
            if (globalPending) return;
            globalPending = true;
            requestAnimationFrame(updateScrollSystems);
          },
          { passive: true }
        );
        let resizePending = false;
        window.addEventListener(
          "resize",
          () => {
            if (resizePending) return;
            resizePending = true;
            requestAnimationFrame(() => {
              resizePending = false;
              setupEditionWall();
              updateScrollSystems();
            });
          },
          { passive: true }
        );
        updateScrollSystems();

        if (finePointer.matches && !motionReduced) {
          root.querySelectorAll("[data-tilt]").forEach((card) => {
            card.addEventListener("pointermove", (event) => {
              const bounds = card.getBoundingClientRect();
              const x = (event.clientX - bounds.left) / bounds.width - 0.5;
              const y = (event.clientY - bounds.top) / bounds.height - 0.5;
              card.style.setProperty("--card-x", `${(x + 0.5) * 100}%`);
              card.style.setProperty("--card-y", `${(y + 0.5) * 100}%`);
              card.style.transform = `perspective(1000px) rotateX(${y * -2}deg) rotateY(${x * 2.5}deg)`;
            });
            card.addEventListener("pointerleave", () => {
              card.style.transform = "";
            });
          });

          root.querySelectorAll(".gallery__item").forEach((item) => {
            item.addEventListener("pointermove", (event) => {
              const bounds = item.getBoundingClientRect();
              item.style.setProperty("--gallery-x", `${((event.clientX - bounds.left) / bounds.width) * 100}%`);
              item.style.setProperty("--gallery-y", `${((event.clientY - bounds.top) / bounds.height) * 100}%`);
            });
          });
        }

        const gallery = root.querySelector("[data-gallery]");
        if (gallery && finePointer.matches) {
          let dragging = false;
          let startX = 0;
          let startScroll = 0;
          gallery.addEventListener("pointerdown", (event) => {
            dragging = true;
            startX = event.clientX;
            startScroll = gallery.scrollLeft;
            gallery.classList.add("is-dragging");
            gallery.setPointerCapture(event.pointerId);
          });
          gallery.addEventListener("pointermove", (event) => {
            if (!dragging) return;
            gallery.scrollLeft = startScroll - (event.clientX - startX);
          });
          const finish = () => {
            dragging = false;
            gallery.classList.remove("is-dragging");
          };
          gallery.addEventListener("pointerup", finish);
          gallery.addEventListener("pointercancel", finish);
        }
        gallery?.addEventListener("keydown", (event) => {
          if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
          event.preventDefault();
          const card = gallery.querySelector(".gallery__item");
          const distance = (card?.getBoundingClientRect().width || gallery.clientWidth * 0.7) + 22;
          gallery.scrollBy({
            left: event.key === "ArrowRight" ? distance : -distance,
            behavior: motionReduced ? "auto" : "smooth"
          });
        });

        const quantity = root.querySelector(".quantity input");
        root.querySelectorAll("[data-quantity]").forEach((button) => {
          button.addEventListener("click", () => {
            if (!quantity) return;
            const current = Number.parseInt(quantity.value, 10) || 1;
            const minimum = Number.parseInt(quantity.min, 10) || 1;
            const step = Number.parseInt(quantity.step, 10) || 1;
            const parsedMaximum = quantity.max ? Number.parseInt(quantity.max, 10) : Number.MAX_SAFE_INTEGER;
            const maximum = Math.max(minimum, parsedMaximum);
            const candidate = current + Number.parseInt(button.dataset.quantity, 10) * step;
            const clamped = Math.max(minimum, Math.min(maximum, candidate));
            quantity.value = String(minimum + Math.floor((clamped - minimum) / step) * step);
          });
        });

        const productForm = root.querySelector(".purchase__form");
        productForm?.addEventListener("submit", (event) => {
          event.preventDefault();
          const status = root.querySelector("[data-purchase-status]");
          const buyButton = productForm.querySelector("[data-buy-now]");
          const variantInput = productForm.querySelector('input[name="id"]');
          if (!buyButton || !variantInput || !quantity) return;
          const minimum = Number.parseInt(quantity.min, 10) || 1;
          const step = Number.parseInt(quantity.step, 10) || 1;
          const parsedMaximum = quantity.max ? Number.parseInt(quantity.max, 10) : Number.MAX_SAFE_INTEGER;
          const maximum = Math.max(minimum, parsedMaximum);
          const requestedQuantity = Number.parseInt(quantity.value, 10) || minimum;
          const clampedQuantity = Math.max(minimum, Math.min(maximum, requestedQuantity));
          const checkoutQuantity = minimum + Math.floor((clampedQuantity - minimum) / step) * step;
          buyButton.disabled = true;
          status.textContent = "Opening secure checkout…";
          window.location.assign(`${root.dataset.cartUrl}/${encodeURIComponent(variantInput.value)}:${checkoutQuantity}`);
        });

        const menuButton = root.querySelector(".nav__menu");
        const mobileMenu = root.querySelector(".nav__mobile");
        menuButton?.addEventListener("click", () => {
          const open = menuButton.getAttribute("aria-expanded") === "true";
          menuButton.setAttribute("aria-expanded", String(!open));
          mobileMenu.classList.toggle("is-open", !open);
        });
      })();
